module.exports = __webpack_public_path__ + "media/images/crypto/4-b9c505072f2d071e439862a294946f01.png";